import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
// import ReactDOM from 'react-dom';
import style from './style.module.css';
import Item from './Item';
import NumberFormat from 'react-number-format';
// import CurierLocation from '../CurierLocation';

@inject((store) => {
    const { ifaceMngr, myShopApiStore } = store;
    return { ifaceMngr, myShopApiStore };
})

@observer
class Basket extends React.Component {
    
    handleAddToCartClick = () => {
        const { basketHistory, addToCart, closeCartItemForm} = this.props.myShopApiStore;

        if(basketHistory){
            basketHistory.products.forEach(product => {
                addToCart(product.shopProduct, product.unitType);
                closeCartItemForm();
            }); 
        }
    }

    render() {
        const { basketHistory } = this.props.myShopApiStore;
        const { shopData } = this.props.myShopApiStore;
        const { currencyName } = shopData.country;
        const { i18nextLng } = this.props.ifaceMngr;

        const deliveryCost = basketHistory?.deliveryCost??0;
        const totalToPay = basketHistory?.totalPay??0;
        const totalCost = basketHistory?.orderRecountedTotal - deliveryCost;
        const orderPromotions = basketHistory?.orderPromotions;
        const totalTax = basketHistory?.totalTax;
        const serviceFee = basketHistory?.serviceFee??null;
        const totalText = orderPromotions?.length > 0 || basketHistory?.couponId ? ('Product cost before discounts') : (
            totalToPay != totalCost ? ('The cost of products') : ('Total to pay')
        );
        
        const { t } = this.props;
        return (
            <div className={style.Container}>
                <div className={style.CancelXBtn}>
                    <span onClick={this.props.hideBasket}>✕</span>
                </div>
                <div className={style.OrderNumber} >{` ${t('_order number')} #${basketHistory?.id}`}</div>
                <div className={style.List}>
                    <iframe 
                        src={basketHistory?.link+'&lang='+i18nextLng} 
                        title="QR Code"
                        className={style.iframOrder}
                        loading="lazy"
                    ></iframe>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Basket);